exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#CurvesModal .v--modal-box.v--modal{min-height:600px!important;min-width:400px!important}#CurvesModal .v-card.v-card--flat.v-sheet.theme--light{height:100%!important}#CurvesModal .modal__footer{display:none}#CurvesModal .addCurveBtn{margin-top:10px;margin-left:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7640ac4c","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/viewer/modelWat/modals/CurvesModal.vue
// module id = 1848
// module chunks = 0